import { N1EventForm } from "./form";

export function N1EventsNew() {
  return <N1EventForm isNew />;
}
